module.exports = __webpack_public_path__ + "static/media/supertlv_big.274dfef4.png";